import { Loader, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { Wrapper } from './FeedbackCards';

const FadeInLoader = styled(Loader)`
  @keyframes fadeInDelayed {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  animation: fadeInDelayed 2s ease;
`;

const PlaceholderFeedbackCardWrapper = styled(Wrapper)`
  height: 146px; /* this is the height of a FeedbackCard with two lines of text */
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    -45deg,
    ${tokens.color.bg_danger},
    ${tokens.color.bg_hover},
    ${tokens.color.bg_success}
  );
  background-size: 400% 400%;
  animation: gradient 5s ease infinite;

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

export const PlaceholderFeedbackCard = (): JSX.Element => {
  return (
    <PlaceholderFeedbackCardWrapper>
      <FadeInLoader />
    </PlaceholderFeedbackCardWrapper>
  );
};
